import { usesLanguages } from '@trello/locale';
import type { PIIString } from '@trello/privacy';
import {
  convertToPIIString,
  dangerouslyConvertPrivacyString,
} from '@trello/privacy';

import type { TemplateLanguage } from './types';

const DEFAULT_LOCALE = 'en-US';
export const getDefaultLocale = () => {
  return convertToPIIString(DEFAULT_LOCALE);
};
export const getDefaultLanguage = (): TemplateLanguage => {
  return {
    __typename: 'TrelloTemplateGalleryLanguage',
    language: 'en',
    locale: DEFAULT_LOCALE,
    description: 'English',
    localizedDescription: 'English',
    enabled: true,
  };
};

export const showGalleryLocalization = () =>
  usesLanguages(['en', 'pt-BR', 'fr']);

export const getTemplateLanguageEnabledFromMemberLocale = (
  locale: PIIString,
  languages: TemplateLanguage[],
): TemplateLanguage => {
  const language = locale.split('-')[0];
  const languageMemberMatch = languages.find(
    (l: TemplateLanguage) =>
      l.enabled &&
      (dangerouslyConvertPrivacyString(locale) === l.locale ||
        language === convertToPIIString(l.language)),
  );

  return languageMemberMatch || getDefaultLanguage();
};

export const Helpers = {
  showGalleryLocalization,
  getTemplateLanguageEnabledFromMemberLocale,
};
